import { AbstractConfDataCommand } from "./abstractConfDataCommand";
import { ConfValueArgument } from "../arguments/confValueArgument";
import { ConfPropertyValueArgument } from "../arguments/confPropertyValueArgument";

export class UpdateCommand extends AbstractConfDataCommand {
  tryNextPossibleValue?: Boolean;
  confValue?: ConfValueArgument;
  confPropertyValue?: ConfPropertyValueArgument;
}